import { Provider } from '@angular/core';
import { OrderRepositoryPort } from '../domain/repositories/order.repository.port';
import { OrderRepository } from './repositories/order.repository';

export const ORDER_PROVIDERS: Provider[] = [
  {
    provide: OrderRepositoryPort,
    useClass: OrderRepository,
  },
];
